<template>
  <div class="page page__has-bar">
    <div class="page__bd weui-form">
      <div class="weui-form__text-area" v-if="activity.sa_name">
        <h2 class="weui-form__title">{{ activity.sa_name }}</h2>
        <h4>签到登记</h4>
      </div>
      <div class="weui-form__control-area">
        <div class="weui-cells">
          <div class="weui-cell weui-required">
            <div class="weui-cell__hd">
              <label for class="weui-label">您的手机号</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                ref="ss_mobile"
                v-model="form.ss_mobile"
                placeholder="请输入您的手机号"
              />
            </div>
            <div class="weui-cell__ft" v-show="!isMobileValid">
              <a class="weui-btn_reset weui-btn_icon">
                <i class="weui-icon-info-circle"></i>
              </a>
            </div>
          </div>
          <div class="weui-cell weui-cell_active weui-cell_vcode weui-required">
            <div class="weui-cell__hd">
              <label for class="weui-label">验证码</label>
            </div>
            <div class="weui-cell__bd">
              <input
                v-model="form.validCode"
                class="weui-input"
                placeholder="请输入验证码"
                maxlength="6"
                @input="onValidCodeInput"
              />
            </div>
            <div class="weui-cell__ft" @click="getValidCode">
              <button
                class="weui-btn weui-btn_default weui-vcode-btn"
                :class="{ 'weui-btn_disabled': isLocked }"
                style="width: 130px"
              >
                <span v-if="!waitTime">获取</span
                ><span v-else>{{ waitTime }}秒后再试</span>
              </button>
            </div>
          </div>
          <div class="weui-cell weui-required">
            <div class="weui-cell__hd">
              <label for class="weui-label">您的姓名</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.ss_username"
                placeholder="请输入您的姓名"
              />
            </div>
          </div>
          <qcc-search-box
            label="您的公司"
            placeholder="请输入您的公司名称"
            v-model="form.ss_corpname"
            @select="onCompanySelect($event)"
            ref="qccBox"
            :required="true"
          ></qcc-search-box>
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">您的职务</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.ss_job"
                placeholder="请输入您的职务"
              />
            </div>
          </div>
          <!-- <div
            class="weui-cell weui-cell_select weui-cell_select-after"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">您是我们的</label>
            </div>
            <div class="weui-cell__bd">
              <select
                class="weui-select"
                v-model="form.ss_identity"
                placeholder="请选择"
              >
                <option value="1">供应商、潜在供应商</option>
                <option value="2">客户、潜在客户</option>
                <option value="4">服务商、潜在服务商</option>
                <option value="8">代理商、潜在代理商</option>
                <option value="0">其他关系</option>
              </select>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >确认</a
      >
    </div>
  </div>
</template>

<script>
import QccSearchBox from "@/components/field/QccSearchBox";
import Finger from "@/util/finger.js";
import Validator from "@/util/validator.js";
import wait from "@/mixins/wait.js";

export default {
  components: {
    QccSearchBox,
  },
  mixins: [wait],
  data() {
    return {
      form: {
        sa_uid: null,
        ss_username: null,
        ss_mobile: null,
        ss_corpname: null,
        ss_job: null,
        validCode: null,
      },
      activity: {
        sa_name: null,
      },
    };
  },
  computed: {
    isMobileValid() {
      return Validator.isMobile(this.form.ss_mobile);
    },
    isLocked() {
      const me = this;
      return !me.isMobileValid || me.isWaiting;
    },
    isMobileChecked() {
      const me = this;
      return me.isMobileValid && me.form.validCode;
    },
  },
  created() {
    var me = this,
      uid = me.$route.query.uid;
    if (uid) {
      me.form.sa_uid = uid;
      // 二维码信息
      me.getActivity(uid);
    }
    // 客户端标记
    me.initClient();
  },
  watch: {
    "form.ss_mobile": function (value) {
      if (
        value &&
        value.length >= 11 &&
        this.$refs.ss_mobile == document.activeElement
      ) {
        this.searchUserByMobile(value);
      }
    },
  },
  methods: {
    /**
     * 获取二维码信息
     */
    getActivity(uid) {
      var me = this;
      me.$ajax({
        url: "/api/open/crm/activity/read/" + uid,
      }).then(function (res) {
        var data = res.data;
        if (data) {
          me.activity = data;
        } else {
          me.$weui.topTips("二维码已失效", 3000);
        }
      });
    },
    initClient() {
      var me = this,
        clientId = Finger.get();
      me.form.ss_clientid = clientId;
      me.getClientInfo(clientId);
    },
    /**
     * 载入个人信息
     */
    getClientInfo(clientId) {
      var me = this;
      me.$ajax({
        url: "/api/open/account/read/" + clientId,
      }).then(function (res) {
        var data = res.data,
          form = me.form;
        if (data) {
          form.ss_username = data.name;
          form.ss_mobile = data.mobile;
          form.ss_corpname = data.corpname;
          form.ss_corpcredit = data.corpcredit;
          form.ss_job = data.job;
          if (me.$refs.qccBox) {
            me.$refs.qccBox.keyword = data.corpname;
          }
        }
      });
    },
    save() {
      var me = this,
        form = me.form;
      if (!form.ss_username) {
        me.$weui.topTips("请输入您的姓名", 2000);
      } else if (!form.ss_mobile) {
        me.$weui.topTips("请输入您的手机号", 2000);
      } else if (!form.validCode) {
        me.$weui.topTips("请验证您的手机号", 2000);
      } else {
        me.$loading({
          url: "/api/open/crm/activity/sign",
          method: "POST",
          jsonData: form,
        }).then(function (res) {
          if (res.success) {
            me.$router.push({
              name: "OpenActivitySign",
              params: {
                uid: form.sa_uid,
                clientId: form.ss_clientid,
              },
              query: {
                uid: form.sa_uid,
                clientId: form.ss_clientid,
              }
            });
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        });
      }
    },
    /**
     * 企业名模糊查询选择
     */
    onCompanySelect(company) {
      var code = company.creditCode;
      if (!code || !code.length) {
        code = company.no;
      }
      this.form.ss_corpcredit = code;
    },
    /**
     * 如果有导入过人员名单，当签到的人输入手机号之后，自动匹配人员信息
     */
    searchUserByMobile() {
      var me = this,
        form = me.form,
        mobile = form.ss_mobile;
      setTimeout(function () {
        if (!me.searching && mobile && mobile.length >= 11) {
          me.searching = true;
          me.$ajax({
            url: "/api/open/crm/activity/user_by_mobile",
            params: {
              uid: form.sa_uid,
              mobile,
            },
          })
            .then(function (res) {
              me.searching = false;
              me.setClientInfo(res.data);
            })
            .catch(function () {
              me.searching = false;
            });
        }
      }, 50);
    },
    setClientInfo(data) {
      if (!data || !data.length) {
        return;
      }
      var me = this,
        user = data[0],
        form = me.form;
      form.ss_suid = user.id;
      form.ss_username = user.su_username;
      form.ss_job = user.su_job;
      form.ss_corpname = user.su_corpname;
      if (me.$refs.qccBox) {
        me.$refs.qccBox.keyword = user.su_corpname;
      }
    },
    /**
     * 获取验证码
     */
    getValidCode() {
      const me = this;
      if (me.isLocked) {
        return;
      }
      me.addWaitTask();
      me.$loading({
        url: "/api/open/crm/activity/sign_vcode",
        method: "POST",
        params: {
          mobile: me.form.ss_mobile,
        },
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast("发送成功", 2000);
        } else {
          me.$weui.topTips("发送失败", 3000);
          me.clearWaitTask();
        }
      });
    },
    /**
     * ios监听事件bug，导致验证码可能输入两次
     */
    onValidCodeInput(e) {
      var value = e.target.value;
      if (value && value.length > 6) {
        this.form.validCode = value.slice(0, 6);
      }
    }
  },
};
</script>